:host {
  display: block;
}


// -------------------------------------------------------------
//                            mobile
// -------------------------------------------------------------
@media (max-width: 991px) {

  .bleached-silk-background {
    background-color: var(--color-bleached-silk);
  }


  .nav-page {
    position: absolute;
    top: 0;
    left: 0;
    background-color: white;
    width: 100%;
    height: 100%;
    overflow-y: auto;

    &.second,
    &.third {
      padding-top: 20px;

      @media (min-width: 768px) {
        padding-top: 0;
      }

      li:first-child {
        border-top: 1px solid var(--color-silver);
      }
    }


    &.slide-in {
      animation-name: slide-in;
      animation-duration: 0.3s;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
    }

    @keyframes slide-in {
      0% {
        transform: translateX(100%);
      }

      100% {
        transform: translateX(0);
      }
    }

    &.slide-out {
      animation-name: slide-out;
      animation-duration: 0.3s;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
    }

    @keyframes slide-out {
      0% {
        transform: translateX(0);
      }

      100% {
        transform: translateX(100%);
      }
    }

  }

  .back {
    padding: 18px;
    font-size: 14px;
    font-family: var(--primary-font);
    text-transform: uppercase;
    cursor: pointer;

    &:hover {
      color: var(--color-silver);
    }

    lilu-icon {
      padding-right: 9px;
    }
  }

  h2 {
    padding: 18px;
    margin-top: 10px;
    font-family: var(--primary-font);
    font-weight: var(--font-weight-semibold);
    font-size: 18px;
    margin-bottom: 0;
    text-transform: uppercase;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  nav {
    height: calc(100vh - 86px);

    @media (min-width: 768px) {
      height: calc(100vh - 75px);
    }

    --nav_link-color-selected: var(--color-nero);

    .menu.first {
      --nav_link-font-size: 14px;
      --nav_link-font-weight: 400;
      text-transform: uppercase;
    }

    .item {
      position: relative;
      padding: 18px;
      cursor: pointer;

      &:hover {
        background-color: darken($color: white, $amount: 1);
      }

      .img_container {
        display: none;
      }

      lilu-icon {
        position: absolute;
        top: 0;
        right: 0;
        padding: 25px 4vw;
      }

      border-bottom: 1px solid var(--color-silver);
    }
  }

  .mobile_lang_nav {
    display: flex;
    justify-content: space-evenly;
    margin: 20px 0;

    lilu-button {
      width: 45px;
    }
  }
}


// -------------------------------------------------------------
//                            desktop
// -------------------------------------------------------------
@media (min-width: 992px) {
  .mobile_lang_nav {
    display: none;
  }

  nav {
    position: relative;

    .menu {
      position: absolute;
      top: 0;
      left: 0;
      width: calc(25vw - 45px);
      background-color: white;
      height: calc(var(--navigation-max-rows) * var(--navigation-item-height));
      display: block;

      @media (min-width: 1600px) {
        width: 360px;
      }

      &:not(:first-child) {
        border-left: 1px solid var(--color-silver);
        left: 100%;
      }

      &.first>.item>.img_container {
        left: calc(300% + 1px);
      }

      &.second>.item>.img_container {
        left: calc(200% + 1px);
      }

    }

    .item {
      list-style: none;
      padding-right: 3vw;
      height: var(--navigation-item-height);

      .img_container {
        background-color: white;
        width: 400px;
        padding-left: 2vw;
        max-width: calc(25vw - 45px);

        @media (min-width: 1600px) {
          max-width: 340px;
        }

        position: absolute;
        top:0;
        left: 100%;
        display: none;
      }

      &:hover,
      &.isSelected {
        .img_container {
          display: block;
        }
      }

      --nav_link-color-selected: var(--color-nero);

      &.isSelected {
        --nav_link-color-selected: var(--color-silver);

        .img_container {
          display: block;
        }
      }

      &.hasMenu:after {
        position: relative;
        top: -25px;
        left: calc(20vw - 10px);

        @media (min-width: 1600px) {
          left: 310px;
        }

        font-family: var(--primary-icon-font);
        font-size: 10px;
        content: "\e80c";
        line-height: 1;
      }

      a {
        text-decoration: none;
      }

      lilu-icon {
        display: none;
      }
    }
  }
}
